(function(root,factory){
  'use strict';
  var api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else root.KZReturnsAttachments=api;
})(typeof self!=='undefined'?self:this,function(){
  'use strict';

  var MAX_FILE_SIZE=5*1024*1024;
  var MAX_FILES=5;
  var RASTER_OPTIONS={maxDimension:1568,quality:0.84};
  var MESSAGES={
    too_large:'Imagem muito grande. O tamanho máximo é 5 MB.',
    unsupported:'Formato não suportado. Envie fotos em JPG, PNG, WebP, HEIC ou HEIF.',
    too_many:'Você pode enviar no máximo 5 fotos por mensagem.',
    conversion_failed:'Não foi possível preparar uma das fotos. Tente novamente ou envie em JPG, PNG ou WebP.',
    invalid_output:'Não foi possível validar a foto convertida. Tente novamente ou envie em JPG, PNG ou WebP.'
  };
  var HEIC_BRANDS={
    heic:true,heix:true,hevc:true,hevx:true,
    heim:true,heis:true,hevm:true,hevs:true,
    mif1:true,msf1:true
  };

  function error(code){return{code:code,message:MESSAGES[code]}}

  function matches(bytes,offset,values){
    if(!bytes||bytes.length<offset+values.length)return false;
    for(var i=0;i<values.length;i++)if(bytes[offset+i]!==values[i])return false;
    return true;
  }

  function brandAt(bytes,offset){
    if(bytes.length<offset+4)return '';
    return String.fromCharCode(bytes[offset],bytes[offset+1],bytes[offset+2],bytes[offset+3]);
  }

  function uint32At(bytes,offset){
    return(bytes[offset]*0x1000000)+(bytes[offset+1]<<16)+(bytes[offset+2]<<8)+bytes[offset+3];
  }

  function detectImageType(input){
    var bytes=input instanceof Uint8Array?input:new Uint8Array(input||0);
    if(matches(bytes,0,[0xff,0xd8,0xff]))return'image/jpeg';
    if(matches(bytes,0,[0x89,0x50,0x4e,0x47,0x0d,0x0a,0x1a,0x0a]))return'image/png';
    if(matches(bytes,0,[0x52,0x49,0x46,0x46])&&matches(bytes,8,[0x57,0x45,0x42,0x50]))return'image/webp';
    if(!matches(bytes,4,[0x66,0x74,0x79,0x70])||bytes.length<16)return null;

    var boxSize=uint32At(bytes,0);
    if(boxSize<16||boxSize>bytes.length)return null;
    var boxEnd=boxSize;
    var brands=[brandAt(bytes,8)];
    for(var offset=16;offset+4<=boxEnd;offset+=4)brands.push(brandAt(bytes,offset));
    for(var i=0;i<brands.length;i++)if(brands[i]==='avif'||brands[i]==='avis')return null;
    for(var j=0;j<brands.length;j++)if(HEIC_BRANDS[brands[j]])return'image/heic';
    return null;
  }

  function validateFile(file){
    if(!file||typeof file.size!=='number'||file.size>MAX_FILE_SIZE){
      return Promise.resolve({ok:false,error:error('too_large')});
    }
    var header;
    try{header=file.slice(0,64)}catch(e){return Promise.resolve({ok:false,error:error('unsupported')})}
    if(!header||typeof header.arrayBuffer!=='function')return Promise.resolve({ok:false,error:error('unsupported')});
    return Promise.resolve(header.arrayBuffer()).then(function(buffer){
      var type=detectImageType(new Uint8Array(buffer));
      if(!type)return{ok:false,error:error('unsupported')};
      return{ok:true,attachment:{file:file,type:type}};
    }).catch(function(){return{ok:false,error:error('unsupported')}});
  }

  function ingestFiles(current,incoming){
    var accepted=Array.isArray(current)?current.slice(0,MAX_FILES):[];
    var candidates=Array.prototype.slice.call(incoming||[]);
    var errors=[];
    var chain=Promise.resolve();
    candidates.forEach(function(file){
      chain=chain.then(function(){
        return validateFile(file).then(function(result){
          if(!result.ok){errors.push(result.error);return}
          if(accepted.length>=MAX_FILES){errors.push(error('too_many'));return}
          accepted.push(result.attachment);
        });
      });
    });
    return chain.then(function(){return{attachments:accepted,errors:errors}});
  }

  function decodeBase64(data){
    try{
      if(typeof atob==='function'){
        var binary=atob(data);
        var bytes=new Uint8Array(binary.length);
        for(var i=0;i<binary.length;i++)bytes[i]=binary.charCodeAt(i);
        return bytes;
      }
      if(typeof Buffer!=='undefined')return new Uint8Array(Buffer.from(data,'base64'));
    }catch(e){}
    return new Uint8Array(0);
  }

  function validJpegOutput(output){
    if(!output||output.type!=='image/jpeg'||typeof output.data!=='string'||!output.data)return false;
    return detectImageType(decodeBase64(output.data))==='image/jpeg';
  }

  function createHeicConverter(importModule,decoderUrl){
    var decoderPromise=null;
    function loadDecoder(){
      if(!decoderPromise){
        decoderPromise=Promise.resolve().then(function(){return importModule(decoderUrl)}).then(function(module){
          if(!module||typeof module.heicTo!=='function')throw new Error('HEIC decoder export unavailable');
          return module.heicTo;
        });
        decoderPromise=decoderPromise.catch(function(error){
          decoderPromise=null;
          throw error;
        });
      }
      return decoderPromise;
    }
    return function(file){
      return loadDecoder().then(function(heicTo){
        return heicTo({blob:file,type:'image/jpeg',quality:0.84});
      });
    };
  }

  function prepareImage(attachment,adapters){
    var source=Promise.resolve(attachment&&attachment.file);
    if(attachment&&attachment.type==='image/heic'){
      source=source.then(function(file){return adapters.convertHeic(file)});
    }
    return source.then(function(blob){
      return adapters.rasterize(blob,{maxDimension:RASTER_OPTIONS.maxDimension,quality:RASTER_OPTIONS.quality});
    }).then(function(output){
      if(!validJpegOutput(output))return{ok:false,error:error('invalid_output')};
      return{ok:true,image:{data:output.data,type:'image/jpeg'}};
    }).catch(function(){return{ok:false,error:error('conversion_failed')}});
  }

  function prepareImages(attachments,adapters){
    var pending=Array.isArray(attachments)?attachments:[];
    var images=[];
    var chain=Promise.resolve({ok:true});
    pending.forEach(function(attachment){
      chain=chain.then(function(result){
        if(!result.ok)return result;
        return prepareImage(attachment,adapters).then(function(prepared){
          if(!prepared.ok)return prepared;
          images.push(prepared.image);
          return{ok:true};
        });
      });
    });
    return chain.then(function(result){
      if(!result.ok)return{ok:false,error:result.error};
      return{ok:true,images:images};
    });
  }

  return{
    detectImageType:detectImageType,
    validateFile:validateFile,
    ingestFiles:ingestFiles,
    createHeicConverter:createHeicConverter,
    prepareImage:prepareImage,
    prepareImages:prepareImages
  };
});
